const rawApiUrl = import.meta.env.VITE_API_URL ?? "";
const API_URL = rawApiUrl.replace(/\/$/, "");

export default API_URL;
